import React, { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { captureError } from "@shared/lib/monitoring/sentry";

/**
 * 라우트 렌더/로더 에러 전역 fallback. [E3]
 * createBrowserRouter 는 라우트 에러를 errorElement 로 처리하고 상위 React 경계로 전파하지 않으므로,
 * 최상위 라우트(/ · /home/* · *)에 붙여 로그인·404·셸·페이지 렌더 크래시를 모두 잡는다(블랭크 화면 방지 + 텔레메트리).
 */
export default function RouteError() {
    const error = useRouteError();

    useEffect(() => {
        console.error("라우트 에러:", error);
        captureError(error, { kind: "route-error" }); // DSN 미설정 시 no-op
    }, [error]);

    return (
        <div
            role="alert"
            style={{
                minHeight: "60vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
                padding: 24,
                textAlign: "center",
            }}
        >
            <p style={{ fontSize: 16, color: "#333" }}>
                문제가 발생했습니다. 잠시 후 다시 시도해주세요.
            </p>
            <div style={{ display: "flex", gap: 12 }}>
                <button
                    onClick={() => window.location.reload()}
                    style={{ height: 36, padding: "0 16px", cursor: "pointer" }}
                >
                    새로고침
                </button>
                <button
                    onClick={() => {
                        window.location.href = "/";
                    }}
                    style={{ height: 36, padding: "0 16px", cursor: "pointer" }}
                >
                    홈으로
                </button>
            </div>
        </div>
    );
}
